import React from 'react';
import {Redirect} from 'react-router-dom';
import { routePaths } from 'services/routing';

export default function LabResultNavigation(){
  return <Redirect to={routePaths.healthObservationLabResults} />;
}
